import React from 'react'

import FAIcon from '../FAIcon'

export default ({ children, className, ...props }) => (
  <button type="button" className={`btn btn-link text-uppercase font-weight-bold ${className}`} {...props}>
    <FAIcon name="minus-circle" /> {children}
  </button>
)
